if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"collection-form","remotes":[]},
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}